import * as React from "react";
import { forwardRef } from "react";
const SvgPlay = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M26.262 18.95v62.1c0 3.783 4.382 5.877 7.326 3.503l38.476-31.051a4.5 4.5 0 0 0 0-7.004l-38.476-31.05c-3.275-2.075-7.249.01-7.326 3.501m9 9.413L62.072 50l-26.81 21.637Z" />
  </svg>
);
const ForwardRef = forwardRef(SvgPlay);
export default ForwardRef;
